import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "use", "className"];
import { Component } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
class BannerButton extends Component {
  render() {
    const _this$props = this.props,
      {
        children,
        use,
        className
      } = _this$props,
      props = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(UIButton, Object.assign({}, props, {
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      use: use || 'tertiary',
      className: className || 'm-left-4',
      size: "extra-small",
      children: children
    }));
  }
}
BannerButton.displayName = 'BannerButton';
export default BannerButton;